import { Select, Space } from 'antd';
import Input from 'antd/lib/input';
import { get, intersection, isEmpty } from 'lodash';
import moment from 'moment';
import { func } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import actions from '../../../redux/actions';
import dispatch from '../../../utils/dispatch';

const { Search } = Input;

export default function DomainFilter({ setList }) {
  const [searchTerm, setSearchTerm] = useState({ domain: '', date: '' });
  const [select, setSelect] = useState('all');
  const listWebsite = useSelector(state => {
    return get(state, 'website.list.data', { count: 0, results: [], next: false });
  });

  useEffect(() => {
    // const newSearchTerm = omitBy(searchTerm, isEmpty);
    const { domain, date } = searchTerm;
    const domainSearchList = listWebsite.results.filter(item => {
      return item.domain.includes(domain);
    });
    const dateSearchList = isEmpty(date)
      ? [...listWebsite.results]
      : listWebsite.results.filter(item => {
          return moment(item.created_at).format('DD/MM/YYYY') === date;
        });
    const result = intersection(domainSearchList, dateSearchList);
    setList(result);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  const handleSearch = value => {
    setSearchTerm({ ...searchTerm, domain: value });
  };

  const onSelect = value => {
    setSelect(value);
    if (value === 'disabled') {
      dispatch(actions.getWebsiteListDrawler({ limit: 3000, isDisable: true }));
    } else dispatch(actions.getWebsiteListDrawler({ limit: 3000 }));
  };

  return (
    <Space size="middle">
      <Search name="domain" placeholder="Domain name" onSearch={handleSearch} />
      <Select
        style={{ width: 180 }}
        onChange={onSelect}
        value={select}
        options={[
          { value: 'all', label: 'Tất cả' },
          { value: 'disabled', label: 'Disabled địa chỉ Mỹ' }
        ]}
      />
    </Space>
  );
}

DomainFilter.propTypes = {
  setList: func
};

DomainFilter.defaultProps = {
  setList: () => {}
};
